import BaseAction from './BaseAction.js';
import {setSelectedPianoRollSteps} from 'actions/index.js';
import Track from 'track/Track.js';
import AddStepAction from './addStepAction.js';

class DeleteStepsAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    // stepNumber can be a floating value, (the remainder
    // of which indicates the unquantized offset).
    // 
    // Any mutation of the step pattern for any track
    // which requires adding a step must come through here
    execute({track, steps}, updateRedux=true) {
        if (track === undefined) {
            return {
                stepsDeleted: [],
            };
        }
        let pattern = track.getEasyPattern();
        let stepAndStepNumbers = pattern.getStepNumbers(steps, Track.baseResolution);
        track.getEasyPattern()
            .deleteSteps(steps);
        if (updateRedux) {
            track.updateSteps();
        }
        track.sequencerEngine.dispatch(
            setSelectedPianoRollSteps(undefined));

        // return a list of [step, stepNumber] deleted
        return {stepsDeleted: stepAndStepNumbers};
    }

    undo(action) {
        let addStepAction = new AddStepAction(this.sequencerEngine);
        let steps = action.payload.stepsDeleted;

        for (let i in steps) {
            addStepAction.execute(
                {track: action.payload.track,
                 step: steps[i][0],
                 stepNumber: steps[i][1],
                 resolution: Track.baseResolution
                });
        }

        action.payload.track.updateSteps();
    }

    serialize(action, id) {
        let json = super.serialize(action, id);
        let {operation} = json;
        operation.payload.steps = operation.payload.steps
            .map(x => x.getJson());
        operation.payload.stepsDeleted = operation.payload.stepsDeleted
            .map(
                ([stepData, stepNumber]) =>
                    [stepData.getJson(), stepNumber]);
        return json;
    }

    deserialize(json) {
        let action = super.deserialize(json);
        let payload = action.payload;
        let track = payload.track;
        if (track === undefined) {
            return undefined;
        }

        // given these we need to find the steps that match these numbers
        let steps = payload.steps.map(
            (stepData) =>
                this.deserializeStep(stepData, track, stepData.stepNumber),
                );
        payload.steps = this.getStepsForStepNumbers(steps, track, Track.baseResolution);
        return action;
    }

    getContentId({payload}) {
        return payload.steps.map(x => x && x.id);
    }
}

export default DeleteStepsAction;
